import React, { useEffect } from "react";
import { Button } from "@mui/material";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";

import { useLegalsCheck } from "../../../../../frames/Legals/useLegalsCheck";
import { _commonEventLegalsReq } from "../../../../../../arc/game/events";
import { Locale } from "../../../../../assets/Locale";
import { page } from "../../../../../assets/bases/page";

import "./EventSignIn.scss";
import { useCharacterWizard } from "../../../../../frames/Profile/CharacterWizard/useCharacterWizard";
import { usePop } from "@randajan/jet-react/dom/modal";
import { SignSummary } from "./SignSummary/SignSummary";

const inviteByToken = async (signPort, signIn)=>{
    const key = "search.invitationToken";
    const token = page.get(key);

    if (!token) { return; }
    const reply = await signPort.act.inviteByToken(token);
    if (reply?.error?.message !== "login_required") { page.remove(key); }
    if (!reply || reply.error) { return; }

    //signIn();
};

export const EventSignIn = ({ event, signPort  })=>{
    const say = Locale.use();
    const { data:eventSign, reply } = signPort;
    const { isPublic, avMode, isOpenToUsers, maxUsersTotal, sureCount } = event;

    const pop = usePop({ lock:true });
    const signLegalWizard = useLegalsCheck(
        legalSigns=>signPort.act.signIn({ legalSigns }),
        [..._commonEventLegalsReq, ...(avMode || [])]
    );

    const signWizard = useCharacterWizard(_=>{
        return signLegalWizard();
        const onSubmit = signLegalWizard;
        const onDone = _=>pop.down();
        pop.up(<SignSummary {...{ onSubmit, event, onDone }}/>);
    });


    useEffect(_=>{ inviteByToken(signPort, signWizard); }, []);
    useEffect(_=>{
        if (reply?.error?.message === "login_required") { page.set("hash.sign", "up"); }
    }, [reply]);

    const locked = !isOpenToUsers || signPort.isStatus("pull", "push") || (!isPublic && !eventSign?.isInvited) || (sureCount >= maxUsersTotal);

    return (
        <Button
            className="BlimpMuiPanel-actionPrimary"
            disabled={locked}
            onClick={_=>signWizard()}
            startIcon={<LoginOutlinedIcon/>}
            type="button"
            variant="contained"
        >
            {say("eventSignInAction")}
        </Button>
    );
};